var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDocumentCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03125 15.1909V7.26231C2.03125 4.34307 4.39776 1.97656 7.317 1.97656H33.3146C34.7163 1.97656 36.0606 2.53395 37.0516 3.52529L44.5256 10.9993C45.517 11.9904 46.0744 13.3346 46.0744 14.7364V44.2626C46.0744 47.1818 43.7079 49.5483 40.7886 49.5483H7.317C4.39776 49.5483 2.03125 47.1818 2.03125 44.2626V41.6197",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 15.1909V7.26231C2.03125 4.34307 4.39776 1.97656 7.317 1.97656H33.3146C34.7163 1.97656 36.0606 2.53395 37.0516 3.52529L44.5256 10.9993C45.517 11.9904 46.0744 13.3346 46.0744 14.7364V44.2626C46.0744 47.1818 43.7079 49.5483 40.7886 49.5483H7.317C4.39776 49.5483 2.03125 47.1818 2.03125 44.2626V41.6197V15.1909Z",
    stroke: "#3158F2",
    strokeWidth: 3.96266,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8878_2947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 49,
    height: 53
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03125 15.1909V7.26231C2.03125 4.34307 4.39776 1.97656 7.317 1.97656H33.3146C34.7163 1.97656 36.0606 2.53395 37.0516 3.52529L44.5256 10.9993C45.517 11.9904 46.0744 13.3346 46.0744 14.7364V44.2626C46.0744 47.1818 43.7079 49.5483 40.7886 49.5483H7.317C4.39776 49.5483 2.03125 47.1818 2.03125 44.2626V41.6197",
    fill: "#848484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 15.1909V7.26231C2.03125 4.34307 4.39776 1.97656 7.317 1.97656H33.3146C34.7163 1.97656 36.0606 2.53395 37.0516 3.52529L44.5256 10.9993C45.517 11.9904 46.0744 13.3346 46.0744 14.7364V44.2626C46.0744 47.1818 43.7079 49.5483 40.7886 49.5483H7.317C4.39776 49.5483 2.03125 47.1818 2.03125 44.2626V41.6197V15.1909Z",
    stroke: "#848484",
    strokeWidth: 3.96266,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8878_2947)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.125,
    y: 26,
    width: 20.1073,
    height: 1.82304,
    rx: 0.911521,
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.125,
    y: 29.2915,
    width: 33.177,
    height: 1.82304,
    rx: 0.911521,
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.125,
    y: 29.2915,
    width: 33.177,
    height: 1.82304,
    rx: 0.911521,
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.125,
    y: 41,
    width: 13.9297,
    height: 1.82304,
    rx: 0.911521,
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.125,
    y: 44.292,
    width: 7.65625,
    height: 1.82304,
    rx: 0.911521,
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.79004,
    y: 4.85791,
    width: 14.9615,
    height: 14.9615,
    rx: 6.12061,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4589 10.979L11.6064 13.8315L9.896 12.1197",
    stroke: "#3158F2",
    strokeWidth: 1.36014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2325 15.1898H36.7356C35.276 15.1898 34.0928 14.0066 34.0928 12.5469V-3.30811",
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2325 15.1898H36.7356C35.276 15.1898 34.0928 14.0066 34.0928 12.5469V-3.30811",
    stroke: "#91A5F2",
    strokeWidth: 3.96266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDocumentCheckLarge);
export default __webpack_public_path__ + "static/media/additional_document_check_large.d16aa50e5ad4b76437ed7e1728b2d44b.svg";
export { ForwardRef as ReactComponent };